import utilisateurApi from "@/api/utilisateurApi"

export async function confirmDeleteUtilisateur(utilisateurId, utilisateurNom, deleteCallback = null) {
    let {isConfirmed} = await this.$swal({
        title: 'Supprimer Utilisateur',
        text: `Etes-vous sûr de vouloir supprimer le utilisateur ${utilisateurNom}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Confirmer',
        cancelButtonText: "Annuler",
        customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
    })

    if(isConfirmed)
        await this.deleteUtilisateur(utilisateurId, deleteCallback);
}

export async function deleteUtilisateur(utilisateurId, deleteCallback = null) {
    if(this.hasOwnProperty("deleting"))
        this.deleting = true;
    try {
        await utilisateurApi.deleteUtilisateur(utilisateurId);
        this.showToast("success", "Utilisateur supprimé", "CheckIcon")
        if(deleteCallback != null && typeof deleteCallback === "function")
            deleteCallback(utilisateurId);
        
    } catch(e) {
        console.log("e", e)
        this.showToast("danger", "Une erreur s'est produite", "AlertCircleIcon")
    }
    finally {
        if(this.hasOwnProperty("deleting"))
            this.deleting = false;
    }
}